/* @flow */
import React from 'react';
import PropTypes from 'prop-types';

type Props = {
  onClick: Function,
  data: {
    active: boolean,
    text: string,
  },
};

/**
 * Common Moo style Dropdown that can be extended
 */
const DropdownSelectItemComponent = (props: Props) => (
  <li
    className={`dropdown-select__item ${props.data.active ? 'dropdown-select__item--active' : ''}`}
    onClick={() => props.onClick(props.data)}
  >
    {props.data.text}
  </li>
);

DropdownSelectItemComponent.displayName = 'DropdownSelectItem';

DropdownSelectItemComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  data: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
};

export default DropdownSelectItemComponent;
